import { useMemo } from "react";
import { DATE_FORMAT } from "../../../../../../lib/constants";
import dayjs from "../../../../../../configs/dayjs";

export const useGetDisbursementsDate = (instance: any) => {
  const dateValue: string = useMemo(() => {
    if (instance) {
      const { calculatedDisbursementsDate } = instance;

      return calculatedDisbursementsDate
        ? dayjs(calculatedDisbursementsDate).format(DATE_FORMAT)
        : "";
    }

    return "";
  }, [instance]);

  return { dateValue };
};
